<template>
  <div class="home-pc">
    <div class="header">
      <img class="logo-icon" src="../assets/images/homePc/logo.png" alt="" />
      <div class="header-right">
        <img
          class="fb-icon"
          src="../assets/images/homePc/fb.png"
          alt=""
          @click="goLink('fb', 'click_facebook')"
        />
        <img
          @click="jumpToPurchase"
          class="stored-icon"
          src="../assets/images/homePc/stored.png"
          alt=""
        />
        <img
          @click="jumpToGongLue"
          class="gl-icon"
          src="../assets/images/homeH5/gonglue_icon.png"
          alt=""
        />
      </div>
    </div>

    <div class="page-content">
      <full-page :options="options" ref="fullpage" id="fullpage">
        <div class="section">
          <div class="bg-1">
            <div class="content">
              <div class="play-icon-content">
                <img
                  class="play-icon"
                  src="../assets/images/homePc/play.png"
                  alt=""
                  @click="playVideo"
                />
              </div>
              <div class="game-stat-content" @click="toGameUrl">
                <img
                  class="game-stat-icon"
                  src="../assets/images/homePc/game-stat.png"
                  alt=""
                />
              </div>
              <div class="download-platform">
                <img
                  class="google-play-icon"
                  src="../assets/images/homePc/google-play.png"
                  alt=""
                  @click="goLink('google', 'click_gp_store')"
                />
                <img
                  class="app-store-icon"
                  src="../assets/images/homePc/app-store.png"
                  alt=""
                  @click="goLink('ios', 'click_apple_store')"
                />
              </div>

              <div class="mask" v-show="isShowVideo">
                <div class="video">
                  <div class="close" @click="closeVideo"></div>
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/GYbD6qzBUVY?si=C_LSuYPpDBWJqPIN"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="bg-7">
            <div class="swiper-info">
              <div class="title">
                <img src="../assets/images/sdt_txt.png" alt="" />
              </div>

              <div class="swiper-box">
                <div class="swiper-bg"></div>
                <div class="prev">
                  <img
                    src="../assets/images/homePc/left.png"
                    alt=""
                    class="swiper-button"
                    @click="clickPrev"
                  />
                </div>
                <swiper ref="mySwiper" :options="pc_swiperOptions">
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(item, index) in 5"
                    :key="index"
                  >
                    <img
                      :src="
                        require(`../assets/images/homePc/sdt_${index + 1}.jpg`)
                      "
                      alt=""
                    />
                  </swiper-slide>
                </swiper>
                <div class="next">
                  <img
                    src="../assets/images/homePc/right.png"
                    alt=""
                    class="swiper-button"
                    @click="clickNext"
                  />
                </div>
                <div
                  class="swiper-pagination"
                  slot="pagination"
                  id="custom"
                ></div>
              </div>
            </div>

            <div class="footer">
              <img class="icon1" src="../assets/images/flame.jpg" alt="" />
              <img class="icon2" src="../assets/images/Insane.jpg" alt="" />
              <div class="gongsi">
                共和國科技有限公司<br />
                COPYRIGHT © 2012-2024 ALL RIGHTS RESERVED<br />
                聯繫我們: cs_as@flame-games.com
              </div>
              <img class="icon3" src="../assets/images/12+.jpg" alt="" />
              <div class="tips">
                ※本遊戲部分內容涉及性、遊戲角色穿著凸顯性特徵之服飾或裝扮，但不涉及性暗示。<br />
                ※本遊戲部分內容涉及暴力、打鬥、攻擊等未達血腥之畫面或有輕微恐怖之畫面。<br />
                ※本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力進行適度消費。<br />
                ※請注意遊戲時間，避免沉迷，長時間進行遊戲，容易影響作息，宜適度休息及運動。
              </div>
            </div>
          </div>
        </div>
      </full-page>
    </div>
  </div>
</template>

<script>
import { summitSubscribe, event } from '../global/api/api'
import { analysis } from '../global/js/analysis'

const link_list = {
  fb: 'https://www.facebook.com/Chubby3KD',
  // discord: 'https://discord.gg/YMpsA4VAhW',
  // lounge: 'https://game.naver.com/lounge/Girls_Evolution/home',
  // ytbe: 'https://www.youtube.com/channel/UCIXZ1lEPWwvFeS2-HhJU6AQ',
  ios: 'https://apps.apple.com/tw/app/id6502481057',
  google:
    'https://play.google.com/store/apps/details?id=com.hookylin.tw.qqsg.gp',
  game: 'https://chubby3kd.onelink.me/gZzU/officalwebsite'
  // onestore: 'https://onesto.re/OA00769206',
  // galaxy: 'https://galaxystore.samsung.com/detail/com.hookylin.tw.sftx.galaxystore',

  // detail: 'https://op-static.hookylin.com/user-privacy.html',
  // footer: 'https://op-static.hookylin.com/user-privacy.html'
}
export default {
  name: 'HomePc',
  components: {},
  data() {
    return {
      isShowVideo: false, // 是否显示视频bo

      // 轮播图配置
      pc_swiperOptions: {
        autoplay: {
          delay: 3000, //滚动时间间隔
          disableOnInteraction: false //不可用当用户触摸后，false代表失效
        },
        loop: true, //循环滚动
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1,
        centeredSlides: true,
        // spaceBetween: '-20%',
        // spaceBetween: 10,
        // history: 'love',
        // 设置点击箭头
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            let _html = ''
            for (let i = 1; i <= total; i++) {
              if (current == i) {
                _html += `<div class="swiper-pagination-custom-item swiper-pagination-bullet">
                  <div class="custom active-custom" index="${i}">
                    <div style="border-radius: 50%;height:0.13rem;width:0.13rem;background-color: #9C640A;"></div>
                  </div>
                </div>`
              } else {
                _html += `<div class="swiper-pagination-custom-item swiper-pagination-bullet" tabindex="${i}" aria-label="Go to slide ${i}">
                  <div class="custom" index="${i}">
                    <div style="border-radius: 50%;height:0.13rem;width:0.13rem;background-color: #C0AC95;"></div>
                  </div>
                </div>`
              }
            }
            return _html
          }
        }
      },
      options: {
        // autoScrolling: false,
        // section配置
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        //是否显示导航，默认为false
        // navigation: true,
        //为每个section设置背景色
        sectionsColor: [
          '#000',
          '#000',
          '#000',
          '#000',
          '#000',
          '#000',
          '#000',
          '#000'
        ],
        // 控制动画出现
        onLeave: (index, nextIndex, direction) => {
          this.active_index = nextIndex.index
          if (this.active_index === 1) {
            this.active_role_index = 0
          } else {
            this.active_role_index = ''
          }
          // 动画效果js
          // if (this.active_index !== 0) {
          //   this.isShowHeader = false
          //   this.isUpSideNav = true
          // } else {
          //   this.isShowHeader = true
          //   this.isUpSideNav = false
          // }
        }
      }
    }
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    /**跳转链接 */
    toGameUrl() {
      window.open(link_list['game'], '_blank')
    },
    goLink(key, event_name) {
      if (event_name) {
        this.reserveEvent(event_name)
      }
      if (key === 'google') {
        analysis(0)
      } else if (key === 'ios') {
        analysis(1)
      }
      window.open(link_list[key], '_blank')
    },
    // 埋点事件
    reserveEvent(event_name) {
      const params = {
        game_id: 2,
        source: this.$route.query.from,
        event_name
      }
      event(params)
    },

    jumpToPurchase() {
      this.$router.push({
        path: '/purchase'
      })
    },
    jumpToGongLue() {
      this.$router.push({
        path: '/gonglue'
      })
    },
    playVideo() {
      this.isShowVideo = true
    },
    closeVideo() {
      this.isShowVideo = false
    },
    /* 前一步 */
    clickPrev() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn <= 0 || length == 0) {
        return false
      }
    },
    /* 后一步 */
    clickNext() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn >= length - 1 || length == 0) {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/keyframes.less';
@import '../assets/css/home_pc.less';
</style>
